<app-navbar></app-navbar>

<div class="business-builder">
  <div class="left">
    <app-brochure-button
         fileName="Platinum package.pdf"
         label="Download Brochure"
         className="outline-btn">
      </app-brochure-button>

    <h1> PLATINUM PACKAGE </h1>

    <h2> WHY CHOOSE <br>NexGen Executive Coachin Academy?</h2>

    <h5>FLEXIBILITY:</h5>
    <p>Start and complete your training at your own pace.</p>

    <h5>PRACTICAL APPROACH:</h5>
    <p>Learn from experienced Fortune 500 business professionals.</p>

    <h5>IN-DEPTH MODERN CONTENT:</h5>
    <p>
      Comprehensive training including AI Coaching, neuroscience, advanced coaching frameworks,
      cultural intelligence, cognitive behavioral techniques, and emotional intelligence.
    </p>
  </div>

  <div class="right">
    <div class="image">
            <img src="../../../assets/salesCertification/Screenshot 2025-07-23 010203.png" alt="">
    </div>
    <div class="contant">
      <div class="contant1">
        <h1> PROGRAM OVERVIEW </h1>
        <p>
          NexGen Executive Coaching Academy Platinum Package is designed for professionals seeking 
          <strong>ICF-accredited Executive Coach Certification</strong> without disrupting their careers. 
          Delivered through both live and self-paced formats, this premium program combines flexibility, 
          expertise, and international standards to empower your coaching career.
        </p>
      </div>
      <div class="contant2">
        <h5>nexgencoaches.com</h5>
        <h1>NexGen Executive Coaching Academy</h1>
        <p>Copyright NexGen Executive Coaching Academy, L.L.C. 
          All rights reserved, not for duplication or re-use.</p>
      </div>
    </div>
  </div>
</div>

<div class="main2">
  <div class="left">
    <img src="../../../assets/Brochures/platinum-session.PNG" alt="Platinum Overview">
  </div>

  <div class="middle">
    <p>Program Cost: $9,995 (monthly payment plans available)</p>
    <h2>NEXGEN EXECUTIVE COACHING ACADEMY PLATINUM PACKAGE</h2>
    <p>Earn your ICF-accredited Executive Coaching Certification (ACC & PCC Levels)</p>

    <h5>ICF CERTIFICATION PATHWAY:</h5>
    <ul>
      <li>60 Education Hours for ACC (Level I)</li>
      <li>125 Education Hours for PCC (Level II)</li>
      <li>2-Day Live Virtual Intensive Seminar</li>
      <li>10 Hours of ICF Mentor Coaching</li>
      <li>Business Builder Workshop</li>
      <li>Individual EQ2.0i Assessment</li>
      <li>NexGen Executive Coaching Academy Certificate</li>
      <li>Completion Time: 5–6 months</li>
    </ul>

    <h5>EXCLUSIVE FEATURES:</h5>
    <ul class="prerequisits">
      <li>Two-Year Access to AI-Driven LMS Platform</li>
      <li>Real-Time Barter Coaching Platform</li>
      <li>On-Demand Executive Coaching Videos</li>
      <li>Customizable AI Co-Pilot Coach Assistant</li>
      <li>One-Year Free ICF Membership ($270 value)</li>
      <li>On-Demand Join-Any-Time Live Training Webinars</li>
      <li>Patented NexGen Executive Coaching Academy Mobile App (iOS & Android)</li>
      <li>Specialty Certifications Access</li>
      <li>30-Day Risk-Free Guarantee</li>
    </ul>

    <p class="copyright">Copyright NexGen Executive Coaching Academy, L.L.C. 
      All rights reserved, not for duplication or re-use.</p>
    <p class="bottom">nexgencoaches.com</p>
  </div>

  <div class="right">
    <img src="../../../assets/Brochures/platinum.PNG" alt="Platinum Curriculum Highlights">
  </div>
</div>

<app-footer></app-footer>
